import { ResetFiltersButton } from "@/controls/buttons/ResetFiltersButton";
import { Box, MenuItem, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import type { Moment } from "moment";
import { ExcelButton } from "@/controls/buttons/ExcelButton";
import type { StraightenerProductSize } from "../models/StraightenerRuns";

interface Props {
	start: Moment;
	end: Moment;
	onStartChange: (date: Moment | null) => void;
	onEndChange: (date: Moment | null) => void;
	productSizeId: number | null;
	onProductSizeChange: (id: number | null) => void;
	productSizes: StraightenerProductSize[];
	onExportExcel: () => void;
	onReset: () => void;
	canReset: boolean;
	productTypeId: number | null;
	productTypes: { Id: number; Name: string }[];
	onProductTypeChange: (id: number | null) => void;
}

export const StraightenerRunsToolbar = ({
	start,
	end,
	onStartChange,
	onEndChange,
	productSizeId,
	onProductSizeChange,
	productSizes,
	onExportExcel,
	onReset,
	canReset,
	productTypeId,
	productTypes,
	onProductTypeChange,
}: Props) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				px: 1.5,
				py: 0.75,
				flexWrap: "wrap",
			}}
		>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="Start"
					format="MM/DD/YYYY"
					value={start}
					maxDate={end}
					onChange={onStartChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>
			<Box sx={{ minWidth: 150, maxWidth: 170 }}>
				<DatePicker
					label="End"
					format="MM/DD/YYYY"
					value={end}
					minDate={start}
					onChange={onEndChange}
					slotProps={{ textField: { size: "small", fullWidth: true } }}
				/>
			</Box>

			<Box sx={{ width: 200 }}>
				<TextField
					select
					size="small"
					label="Product Type"
					fullWidth
					value={productTypeId == null ? "" : String(productTypeId)}
					onChange={(e) =>
						onProductTypeChange(
							e.target.value === "" ? null : Number(e.target.value),
						)
					}
				>
					<MenuItem value="">All</MenuItem>
					{productTypes.map((type) => (
						<MenuItem key={type.Id} value={String(type.Id)}>
							{type.Name}
						</MenuItem>
					))}
				</TextField>
			</Box>
			<Box sx={{ width: 240 }}>
				<TextField
					select
					size="small"
					label="Product"
					fullWidth
					value={productSizeId == null ? "" : String(productSizeId)}
					onChange={(e) => {
						const v = e.target.value;
						onProductSizeChange(v === "" ? null : Number(v));
					}}
				>
					<MenuItem value="">All</MenuItem>
					{productSizes.map((ps) => (
						<MenuItem key={ps.Id} value={String(ps.Id)}>
							{ps.Name}
						</MenuItem>
					))}
				</TextField>
			</Box>

			<ResetFiltersButton onClick={onReset} disabled={!canReset} />

			<Box sx={{ flexGrow: 1, minWidth: 8 }} />

			<Box sx={{ width: 200 }}>
				<ExcelButton handleExportToExcel={onExportExcel} />
			</Box>
		</Box>
	);
};
